import { NotifyHelper } from 'classes/helpers/notify.helper';
import env from 'config';
import { UserMsgType } from 'lib_ts/enums/sockets/users';
import {
  LiveboardAuthenticateResponse,
  LiveboardCodeCheckResponse,
} from 'lib_ts/zod/liveboard';
import { useCallback, useState } from 'react';
import { sendSocket } from 'services/socket';

const useLiveboard = () => {
  const [connectLiveboardDialog, setConnectLiveboardDialog] =
    useState<number>();

  const openConnectLiveboardDialog = useCallback(() => {
    setConnectLiveboardDialog(Date.now());
  }, []);

  const closeConnectLiveboardDialog = useCallback(() => {
    setConnectLiveboardDialog(undefined);
  }, []);

  const openLiveboard = useCallback(() => {
    sendSocket<undefined, (response: LiveboardCodeCheckResponse) => void>(
      UserMsgType.U2WS_LiveboardPreAuth,
      undefined, // no need to send any payload
      'useLiveboard',
      undefined,
      (response: LiveboardAuthenticateResponse) => {
        if (!response.success) {
          NotifyHelper.error({
            message_md:
              'We were unable to connect you with a Live Monitor. Please contact support or try again later.',
          });
          return;
        }

        const url = `${env.liveboard_url}?token=${response.token}`;
        window.open(url, '_blank');
      }
    );
  }, []);

  return {
    connectLiveboardDialog,
    openConnectLiveboardDialog,
    closeConnectLiveboardDialog,
    openLiveboard,
  };
};

export default useLiveboard;
